
(function(){
  var HID="data-ss-fold-hid",MS=200;
  function reduced(){try{return window.matchMedia("(prefers-reduced-motion: reduce)").matches}catch(e){return false}}
  function matches(el,sel){try{return !sel||el.matches(sel)}catch(e){return false}}
  // On the first line = starts above the bottom of the row's first item. Items on a
  // line are centred on one axis, so every first-line item overlaps the first one
  // vertically, and a wrapped item starts at or below the first line's bottom.
  function wrapped(el,first){return el.getBoundingClientRect().top>=first.getBoundingClientRect().bottom-0.5}
  function reset(row){
    var st=row.__ssFold,list=row.querySelectorAll("["+HID+"]");
    for(var i=0;i<list.length;i++)list[i].removeAttribute(HID);
    if(st&&st.pill.parentNode)st.pill.parentNode.removeChild(st.pill);
  }
  function chips(row){
    var st=row.__ssFold,out=[];
    for(var c=row.firstElementChild;c;c=c.nextElementSibling){
      if(c===st.head||c===st.pill||!c.getClientRects().length)continue;
      out.push(c);
    }
    return out;
  }
  // Fold to the first line. Answers false, with the row left whole, when nothing
  // that counts has wrapped.
  function fold(row){
    var st=row.__ssFold;
    reset(row);
    var list=chips(row);
    if(!list.length)return false;
    var first=st.head&&st.head.getClientRects().length?st.head:list[0];
    var any=false;
    for(var i=0;i<list.length;i++){if(list[i]!==first&&matches(list[i],st.count)&&wrapped(list[i],first)){any=true;break}}
    if(!any)return false;
    var n=0,end=list.length;
    function hide(el){el.setAttribute(HID,"");if(matches(el,st.count))n++}
    while(end>0&&list[end-1]!==first&&wrapped(list[end-1],first))hide(list[--end]);
    st.pill.textContent=st.more(n);
    row.appendChild(st.pill);
    while(end>0&&list[end-1]!==first&&wrapped(st.pill,first)){hide(list[--end]);st.pill.textContent=st.more(n)}
    return true;
  }
  function setFoldable(row,on){
    var st=row.__ssFold;
    st.foldable=on;
    row.classList.toggle("is-foldable",on);
    row.classList.toggle("is-open",on&&st.open);
    if(!st.head)return;
    if(on){
      st.head.setAttribute("role","button");st.head.setAttribute("tabindex","0");
      st.head.setAttribute("aria-expanded",st.open?"true":"false");
    }else{
      st.head.removeAttribute("role");st.head.removeAttribute("tabindex");st.head.removeAttribute("aria-expanded");
    }
  }
  // Lay the row out for the state it is in, at the width it has now.
  function settle(row){
    var st=row.__ssFold;
    if(!st)return;
    var can=fold(row);
    if(st.open){reset(row);if(!can)st.open=false}
    setFoldable(row,can);
  }
  function toggle(row){
    var st=row.__ssFold;
    if(!st.foldable)return;
    window.clearTimeout(st.t);
    // Read before letting go of a running animation: turning back halfway starts
    // from where the box is, not from where it was headed.
    var from=row.offsetHeight;
    row.style.maxHeight="";row.style.overflow="";
    st.open=!st.open;
    if(st.open)reset(row);else fold(row);
    setFoldable(row,true);
    if(reduced())return;
    var to=row.offsetHeight;
    // Closing, the chips stay laid out while the box shuts over them, and the fold
    // lands at the end: hiding them first would leave an empty box shrinking.
    if(!st.open)reset(row);
    row.style.overflow="hidden";
    row.style.maxHeight=from+"px";
    void row.offsetHeight;
    row.style.maxHeight=to+"px";
    // A timer, not transitionend: a backgrounded tab may never fire one, and the
    // cleanup is what puts the fold back.
    st.t=window.setTimeout(function(){
      row.style.maxHeight="";row.style.overflow="";
      if(!st.open)fold(row);
    },MS+40);
  }
  window.ssFoldRow=function(row,opts){
    if(typeof row==="string")row=document.getElementById(row);
    if(!row)return;
    opts=opts||{};
    var old=row.__ssFold;
    if(old){window.clearTimeout(old.t);if(old.ro)old.ro.disconnect();reset(row);row.style.maxHeight="";row.style.overflow=""}
    var pill=document.createElement("button");
    pill.type="button";
    pill.className="ss-fold-more";
    if(opts.title)pill.title=opts.title;
    var st=row.__ssFold={
      head:opts.head||null,pill:pill,count:opts.count||"",open:false,foldable:false,t:0,ro:null,w:-1,
      more:typeof opts.more==="function"?opts.more:function(n){return "+"+n+" more"}
    };
    row.classList.add("ss-fold-row");
    pill.addEventListener("click",function(){if(!st.open)toggle(row)});
    if(st.head&&!st.head.__ssFoldWired){
      st.head.__ssFoldWired=true;
      st.head.classList.add("ss-fold-head");
      st.head.addEventListener("click",function(){if(row.__ssFold&&row.__ssFold.head===st.head)toggle(row)});
      st.head.addEventListener("keydown",function(e){
        if((e.key==="Enter"||e.key===" ")&&row.__ssFold&&row.__ssFold.foldable){e.preventDefault();toggle(row)}
      });
    }
    settle(row);
    st.w=row.clientWidth;
    // Only a new width can change what fits; a height change is the fold itself.
    if(window.ResizeObserver){
      st.ro=new ResizeObserver(function(){
        var w=row.clientWidth;
        if(w===st.w)return;
        st.w=w;
        settle(row);
      });
      st.ro.observe(row);
    }
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(function(){if(row.__ssFold===st)settle(row)});
  };
})();
